import React from 'react'

export default function LandingCraft() {
    const landcraft = [
        {
        number: '01',
        sub_title: "Your Time",
        title: "Your Time, Untouched",
        text: "From concept through handover, one team manages design, procurement, and every contractor on site — so you never coordinate a vendor or attend a site visit.",
        },
        {
        number: '02',
        sub_title: "Your Standing",
        title: "Designed for Your Standing",
        text: "Built for those who've earned the right to expect more — one point of contact, one standard of execution, from the first sketch to the final walkthrough.",
        },
        {
        number: '03',
        sub_title: "The Craft",
        title: "Nothing Left to Chance",
        text: "Every material, finish, and joint selected and executed to a precise standard — a design vision matched by the discipline of its execution.",
        },
    ]

  return (
    <>
    <section className="landcraft-section">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <h4 className="heading center-heading">Your Time, <br/>Your Standing, Your Craft</h4>
                </div>

                {landcraft.map((item, index) => (
                <div className="col-lg-4 col-md-4" key={index}>
                    <div className="landcraft-card">
                        <div>{item.number}</div>
                        <small>{item.sub_title}</small>
                        <span>{item.title}</span>
                        <p>{item.text}</p>
                    </div>
                </div>
                ))}
            </div>
        </div>
    </section>
    </>
  )
}
